import * as React from 'react';
import Button from '@telia-front/button';
import Card, { CardBottom, CardContent, CardTop } from '@telia-front/card';
import { ClickArea, ClickAreaTrigger } from '@telia-front/click-area';
import Fittext from '@telia-front/fittext';
import Grid, { GridColumn } from '@telia-front/grid';
import Heading from '@telia-front/heading';
import Icon from '@telia-front/icon';
import Text from '@telia-front/text';
const ProductCategoryCard = (props) => {
    const { headingLevel = 3 } = props;
    if (props.style === 'vertical') {
        return (React.createElement(ClickArea, null,
            React.createElement(Card, { padding: "large", className: "product-category-card" },
                React.createElement(CardContent, null,
                    React.createElement(CardTop, null,
                        React.createElement(Text, null,
                            props.icon && React.createElement(Icon, { modifiers: props.icon, size: "xxl" }),
                            React.createElement(Heading, { level: headingLevel, className: "h3" },
                                React.createElement(Fittext, null, props.title)),
                            React.createElement("p", null, props.description))),
                    React.createElement(CardBottom, null,
                        React.createElement(ClickAreaTrigger, null,
                            React.createElement(Button, { text: props.buttonText, url: props.buttonUrl, variant: "secondary", iconRight: "#arrow-right" })))))));
    }
    return (React.createElement(ClickArea, null,
        React.createElement(Card, { className: "product-category-card" },
            React.createElement(CardContent, null,
                React.createElement(Grid, { borderWeight: "thin", noWrap: true, equalHeight: true, gutter: "medium", align: ['between-xs', 'middle-xs'] },
                    React.createElement(GridColumn, { width: ['min'] },
                        React.createElement(Text, { className: "text-center" },
                            React.createElement("p", { className: "product-category-card__icon" }, props.icon && React.createElement(Icon, { modifiers: props.icon, size: "xxl" })))),
                    React.createElement(GridColumn, { width: ['max'], border: ['left-xs'] },
                        React.createElement(Grid, { equalHeight: true, gutter: "medium", align: ['between-xs', 'middle-xs'] },
                            React.createElement(GridColumn, { width: ['xs-12', 'sm-7', 'lg-8'] },
                                React.createElement(Text, null,
                                    React.createElement(Heading, { level: headingLevel, className: "h3" }, props.title),
                                    React.createElement("p", null, props.description))),
                            React.createElement(GridColumn, { width: ['xs-12', 'sm-5', 'lg-4'] },
                                React.createElement(Text, { className: "text-right" },
                                    React.createElement(ClickAreaTrigger, null,
                                        React.createElement(Button, { text: props.buttonText, url: props.buttonUrl, variant: "secondary", iconRight: "#arrow-right" })))))))))));
};
export default ProductCategoryCard;
